import React, { useEffect } from 'react';


export default function IC_customer_ddt_rows({ data, entity, setDataKeyValue }) {

    useEffect(() => {
        if (data.idItemModel && data.idItemModel !== '' && data.idItemModel !== null) {
            if (data.idItemModel.name !== data.name) {
                setDataKeyValue('itemModelName', data.idItemModel.name)
            }
            if (data.idItemModel.code !== data.code) {
                setDataKeyValue('itemModelCode', data.idItemModel.code)
            }
            if (data.idItemModel.price !== data.price) {
                setDataKeyValue('price', data.idItemModel.price)
            }
        }
    }, [data]);

    return (
        <></>
    )
};
